import { useQuery } from '@tanstack/react-query';
import { getTreatmentApproaches } from '@uplift/api';
import { SearchListContained } from '@uplift/ui-v2';
import { PROFILE_ROW_QUERY_KEYS } from '../profile.utils';
import { useL10n } from '@uplift/hooks';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';

export type TreatmentApproachFormProps = {
  hideLabel?: boolean;
};

export type TreatmentApproachFormType = {
  treatmentApproaches: string[];
};

export const TreatmentApproachForm: React.VFC<TreatmentApproachFormProps> = props => {
  const formik = useFormikContext<TreatmentApproachFormType>();
  const l10n = useL10n();
  const { data: treatmentApproaches = [], isInitialLoading: loading } = useQuery(PROFILE_ROW_QUERY_KEYS.treatmentApproach, async () => {
    const response = await getTreatmentApproaches();

    return response.data;
  });

  const optionsDisabled = useMemo(() => {
    if (formik.values.treatmentApproaches.length > 9) {
      return treatmentApproaches
        .filter(approach => !formik.values.treatmentApproaches.includes(approach.id))
      ;
    }
    return [];
  }, [ formik.values.treatmentApproaches, treatmentApproaches ]);

  return (
    <div style={{ height: '100%' }}>
      <SearchListContained
        name="treatmentApproaches"
        options={treatmentApproaches}
        label={props.hideLabel ? undefined : 'Select up to 10 approaches you have experience in'}
        selectionOverviewText="approaches selected"
        placeholder="Search for treatment approaches"
        optionVariant="checkbox"
        getOptionLabel={(option) => option.name}
        emptyMessage={<>Can’t find a treatment approach? Email us at <b>{l10n.helpEmail}</b> with the treatment approach you’re looking for.</>}
        loading={loading}
        fullPageMobileView={true}
        getOptionDisabled={(option) => optionsDisabled.includes(option)}
      />
    </div>
  );
};
